import ChatBackBoneComponent from "./component/chat_backbone_comp";
import ChatLoadingComp from "./component/chat_loading_comp";
import ChatFailedInitComp from "./component/chat_failed_init_comp";
import { useDispatch, useSelector, useStore } from "react-redux";
import { startMessaging } from "./state/chat_slice";
import { useEffect } from "react";

const ChatComponent = () => {
  const dispatch = useDispatch();
  const store = useStore();
  const isInitDone = useSelector((state) => state.chat.isInitDone);
  const isFailedInit = useSelector((state) => state.chat.isFailedInit);

  // Call initChat when the component is mounted
  useEffect(() => {
    startMessaging(dispatch, store);
  }, [dispatch]);

  if (isFailedInit) {
    return <ChatFailedInitComp />;
  }

  if (isInitDone) {
    return <ChatBackBoneComponent />;
  }

  console.log("RENDER CHAT AGAIN0");

  return <ChatLoadingComp />;
};

export default ChatComponent;
